// Config
import paymentTypeConstants from '@constants/paymentTypeConstants';

export const showLockIconPaymentTypes: string[] = [
  paymentTypeConstants.PREPAID_CARD,
  paymentTypeConstants.CREDIT_CARD,
  paymentTypeConstants.SAVED_PAYMENT_CARD,
  paymentTypeConstants.POS_CREDIT,
];
